export default __webpack_public_path__ + "static/media/a037-student-t3-8.f101dbdc.svg";